module.exports = "/dist/img/drag.a6226a73792e2c784eb464a884852ed8.svg";